import React from "react";
import { Box, SxProps, Theme } from "@mui/material";

export interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
  /** Prefix for tabpanel/tab aria ids, e.g. "users" → users-tabpanel-0 */
  idPrefix: string;
  contentSx?: SxProps<Theme>;
}

const TabPanel: React.FC<TabPanelProps> = ({
  children,
  value,
  index,
  idPrefix,
  contentSx,
  ...other
}) => (
  <div
    role="tabpanel"
    hidden={value !== index}
    id={`${idPrefix}-tabpanel-${index}`}
    aria-labelledby={`${idPrefix}-tab-${index}`}
    {...other}
  >
    {value === index && (
      <Box sx={{ pt: { xs: 1.25, md: 1.5 }, ...contentSx }}>{children}</Box>
    )}
  </div>
);

export default TabPanel;
